import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import update from "immutability-helper";
import axios from "axios";
import omit from "lodash/omit";
import isEmpty from "lodash/isEmpty";

// import {adminDeleteItem} from '../../../utils/adminRequestHelper.js';

// Components
import AdminTopTierItems from './AdminTopTierItems';
import Loader from "../../utils/Loader";
import NumberFormat from 'react-number-format'

// CSS
import '../../../css/toptiers.css';

// State
import { addRoute } from '../../../store/actions/route'
import { setpageTitle } from '../../../store/actions/siteInfo'
import { loadTopTiers } from '../../../store/actions/topTier'
import { userTokenUpdate, userLogout } from "../../../store/actions/user";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

class AdminTopTiers extends Component {
    constructor(props){
        super(props)
        this.state = {
            loading: false,
            success: '',
            errors: {},
            editId: null, 
            topTier: {
                name: "",
                discount_type: false,
                discount_value: "",
                scope: 'before',
                id: null
            }
        }
        
        this.topTierBaseState = this.state.topTier;
        this.props.addRoute(this.props.match);
        this.props.setpageTitle('Top Tiers');
    }

    componentDidMount(){
        this.props.loadTopTiers()
    }

    // Add/Update top tier
    addTopTier = () => {
        const { user } = this.props;

        this.setState(
            { loading: true }, 
            () => {
                let item = {
                    id: this.state.editId,
                    ...omit(this.state.topTier, ["discount_type"]),
                    discount_type: this.state.topTier.discount_type ? "dollar" : "percentage",
                    is_editing: this.state.editId !== null ? true : false,
                };

                const token = user.token;
                const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
                return axios
                    .post(REACT_APP_API_URL + "top-tier/", item, { headers: AUTH_HEADER })
                    .then(response => {
						//Check user token
						if (!!response.data.token) {
							this.props.userTokenUpdate("admin", response.data.token);
						}else {
							this.props.userLogout("admin");
						}
                        
						if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
							// Create error object
							let errorObj = "";
							if (!isEmpty(response.data.errors)) {
								errorObj = response.data.errors;
							} else if (!isEmpty(response.data.error)) {
								errorObj = { general: response.data.error };
							} else {
								errorObj = { general: response.data.message };
                            }
                            this.setState({
                                loading: false,
                                errors: errorObj
                            })
                            
						} else {
							this.setState({
                                loading: false,
                                success: response.data.message,
                                editId: null
                            });
                            this.resetForm();
                            this.props.loadTopTiers();
						}
                    })
					.catch(err => {
						if (err.response) {
							this.setState({ loading: false, errors: err.response.data.errors ? err.response.data.errors : err.response.data.message });
						} else {
							this.setState({ loading: false, errors: err.message });
						}
					});
            }
        )
    }

    // deleteItem = (id) => {
    //     const { user } = this.props;

    //     this.setState({
    //         loading: true
    //     }, () => {
    //         adminDeleteItem('top-tier/', id, user.token)
    //             .then(result => {
    //                 this.setState({
    //                     loading: false,
    //                     success: result
    //                 })
    //                 this.resetForm();
    //                 this.props.loadTopTiers();
    //                 console.log(result);
    //             })
    //     })
    // }

    // Delete top tier
    deleteTopTier = (id) => {
        const { user } = this.props;

        if(id === this.state.editId)
            this.resetForm();

        this.setState(
            { loading: true }, 
            () => {
                const token = user.token;
                const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
                return axios
                    .delete(REACT_APP_API_URL + "top-tier/" + id, { headers: AUTH_HEADER })
                    .then(response => {
                        //Check user token
                        if (!!response.data.token) {
                            this.props.userTokenUpdate("admin", response.data.token);
                        }else {
                            this.props.userLogout("admin");
                        }
                        
                        if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
							// Create error object
							let errorObj = "";
							if (!isEmpty(response.data.errors)) {
								errorObj = response.data.errors;
							} else if (!isEmpty(response.data.error)) {
								errorObj = { general: response.data.error };
							} else {
								errorObj = { general: response.data.message };
                            }
                            this.setState({
                                loading: false,
                                errors: errorObj
                            })
                            
                        } else {
                            this.setState({
                                loading: false,
                                errors: {},
                                success: ''
                            });
                            this.resetForm();
                            this.props.loadTopTiers();
                        }
                    })
                    .catch(err => {
                        if (err.response) {
                            this.setState({ loading: false, errors: err.response.data.errors ? err.response.data.errors : err.response.data.message });
                        } else {
                            this.setState({ loading: false, errors: err.message });
                        }
                    });
            }
        )
    }

    editTopTier(index){
        this.setState({
            errors: {},
            success: "",
            editId: index,
            topTier: {
                ...omit(this.props.topTiers[index], ["discount_type"]),
                discount_type: this.props.topTiers[index].discount_type === "percentage" ? false : true
            }
        })
    }

    resetForm = () => {
        this.setState({
            topTier: this.topTierBaseState,
            editId: null
        });
    }

    handleInputChange = (value, name) => {
        this.setState({
            topTier: update(this.state.topTier, {
                [name]: { $set: value }
            })
        })
    }

    handleCheckboxClick = () => {
		this.setState({
			topTier: update(this.state.topTier, {
                discount_type: { $set: !this.state.topTier.discount_type }
            })
		});
    }

    handleSelectBoxChange = (selection) => {
		this.setState({
			topTier: update(this.state.topTier, {
                scope: { $set: selection.value }
            })
		});
    }

    render() {
        const { topTier, errors, loading, success, editId } = this.state;
        const { topTiers } = this.props;

        return (
            <Fragment>
                <h1>Top Tiers</h1>
                <div className="instruction">Top Tiers are specialized groups in which customers can be assigned to. These customers will recieve a set discount on certain products. These products can be assigned seperately for each top tier.</div>
                <div className="tt-form">
                    <div className="tt-left">
                        <h2>Current Top Tiers</h2>
                        <div className="tt-items">
                            {loading ? 
                                <div className="pt2 pb2">
                                    <Loader />
                                </div> :
                                topTiers.map((item, i) => <AdminTopTierItems key={i} topTier={item} index={i} editId={this.state.editId} editTopTier={this.editTopTier.bind(this)} deleteTopTier={(id) => this.deleteTopTier(id)}/>)
                            }
                        </div>
                    </div>
                    <div className="tt-divider"></div>
                    <div className="tt-right">
                        <h2>{editId !== null ? 'Editing - ' + topTier.name : 'Add Top Tier'}</h2>
                        <div className="tt-fields">
                            <div className="tt-field-1">
                                {!!errors && !!errors.name && <div className="error msg_animate">{errors.name}</div>}
                                <div className='tt-label'>Top Tier Name:</div>
                                <input type="text" value={topTier.name} placeholder="Enter name" onChange={e => this.handleInputChange(e.target.value, 'name')}/>
                            </div>
                            <div className="tt-field-2">
                                {!!errors && !!errors.discount_value && <div className="error msg_animate">{errors.discount_value}</div>}
                                <div className='tt-label'>Top Tier Discount:</div>
                                <div>
                                    <label className="tgl">
                                        <input type="checkbox" id="discount_type" value="1" checked={topTier.discount_type} disabled={false} onChange={e => this.handleCheckboxClick(e)} />
                                        <span data-on="$" data-off="%" />
                                    </label>
                                    <NumberFormat value={topTier.discount_value} placeholder="0.00" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onChange={e => this.handleInputChange(e.target.value, 'discount_value')}/>
                                </div>
                            </div>
                        </div>
                        {success && <div className="success msg_animate tt-success" style={{width: '100%'}}>{success}</div>}
                        <div className="tt-buttons">
                            <button className="btn" onClick={() => this.addTopTier()}>{editId !== null ? 'Update' : 'Add New'}</button>
                            {editId !== null &&
                                <button className="btn" onClick={() => this.resetForm()}>Reset</button>
                            }
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin,
        topTiers: state.topTier.topTiers
    }
}

export default connect(mapStateToProps, { addRoute, setpageTitle, loadTopTiers, userTokenUpdate, userLogout })(AdminTopTiers)



// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/AdminTopTiers.js